<template>
    <v-card ref="myApplicationsManager" id="myApplicationsManager">
        <v-card-text>
            <v-data-table :headers="applicationsHeader" :items="data"
                no-data-text="There are no applications at this time" :search="filterTerm" sort-by="name">
                <template v-slot:item.actions="{ item }">
                    <v-btn @click="openDialog(item)" :color="primaryColor" icon>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                    mdi-folder-open
                                </v-icon>
                            </template>
                            <span>View Application</span>
                        </v-tooltip>
                    </v-btn>
                </template>
                <template v-slot:item.getApplicantRole="{ item }">
                    {{ getApplicantRole(item) }}
                </template>
                <template v-slot:item.getApplicationStatus="{ item }">
                    <v-chip dark :color="getStatusColor(item)" small>
                        {{ getStatusLabel(item) }}
                    </v-chip>
                </template>
            </v-data-table>
            <my-application-information :dialog="dialog" :item="currentItem" :user="user" @closeDialog="closeDialog">
            </my-application-information>
        </v-card-text>
    </v-card>
</template>

<script>
import MyApplicationInformation from '../../../components/Student/MyApplications/Information';

export default {
    name: 'my-applications-manager',
    components: {
        MyApplicationInformation
    },
    props: {
        data: {
            required: true
        },
        user: {
            required: true
        }
    },
    data() {
        return {
            applicationsHeader: [{
                    text: 'Residence Term',
                    align: 'start',
                    value: 'residenceTerm',
                },
                {
                    text: 'Registered At',
                    value: 'registeredAt'
                },
                {
                    text: 'Year Of Study',
                    value: 'yearOfStudy'
                },
                {
                    text: 'Applicant Role',
                    value: 'getApplicantRole'
                },
                {
                    text: 'Status',
                    value: 'getApplicationStatus'
                },
                {
                    sortable: false,
                    text: 'Actions',
                    value: 'actions',
                }
            ],
            currentItem: '',
            dialog: false
        }
    },
    methods: {
        closeDialog() {
            this.dialog = false;
        },
        getApplicantRole(item) {
            if (item.hasOwnProperty('applicantRole') && item.applicantRole == "residenceAssistant") {
                return 'Residence Assistant';
            } else if (item.hasOwnProperty('applicantRole') && item.applicantRole == "student") {
                return 'Student';
            }

            return 'N/A';
        },
        getStatusColor(item) {
            if (item.hasOwnProperty('officeUse') && item.applicationStatus == "In-process") {
                return '#3699ff';
            } else if (item.hasOwnProperty('officeUse') && item.officeUse.applicationStatus == "Waiting list") {
                return '#ffa800';
            } else if (item.hasOwnProperty('officeUse') && item.officeUse.applicationStatus == "Completed") {
                return '#1bc5bd';
            } else if (item.hasOwnProperty('officeUse') && item.officeUse.applicationStatus == "Withdrawn") {
                return '#5578eb';
            }

            return '#3f4254';
        },
        getStatusLabel(item) {
            if (item.hasOwnProperty('officeUse') && item.officeUse.applicationStatus) {
                return item.officeUse.applicationStatus;
            }

            return 'Applied';
        },
        openDialog(item) {
            this.currentItem = item;
            this.dialog = true;
        }
    },
    computed: {
        infoColor() {
            return '#5578eb';
        },
        primaryColor() {
            return '#5867dd';
        },
        subAppColor() {
            return '#FFA800';
        },
        warningColor() {
            return '#ffb822'
        }
    }
}
</script>